'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AnchorBibDescriptionInput = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _baseIcons = require('@bibliocommons/base-icons');

var _baseButtons = require('@bibliocommons/base-buttons');

var _baseScreenReaderMessage = require('@bibliocommons/base-screen-reader-message');

var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);

require('../styles/AnchorBibDescriptionInput.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  bib: _react2.default.PropTypes.object.isRequired,
  handleEditAnchorBib: _react2.default.PropTypes.func.isRequired
};

var AnchorBibDescriptionInput = exports.AnchorBibDescriptionInput = function (_BcReactComponent) {
  _inherits(AnchorBibDescriptionInput, _BcReactComponent);

  function AnchorBibDescriptionInput(props) {
    _classCallCheck(this, AnchorBibDescriptionInput);

    var _this = _possibleConstructorReturn(this, (AnchorBibDescriptionInput.__proto__ || Object.getPrototypeOf(AnchorBibDescriptionInput)).call(this, props));

    _this.bindAll('renderAuthor');
    return _this;
  }

  _createClass(AnchorBibDescriptionInput, [{
    key: 'renderAuthor',
    value: function renderAuthor() {
      if (!this.props.bib.get('authors') || this.props.bib.get('authors').size < 1) {
        return false;
      }
      return _react2.default.createElement(
        'div',
        { className: 'author' },
        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'user_list_by_author', values: { author: this.props.bib.get('authors').get(0) } })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'cp-anchor-bib-description-input' },
        _react2.default.createElement(
          'h3',
          { className: 'title', 'data-test-id': 'list-title' },
          this.props.bib.get('title'),
          _react2.default.createElement(
            _baseButtons.TextButton,
            {
              handleClick: this.props.handleEditAnchorBib,
              className: 'edit-anchor-bib',
              'data-test-id': 'edit-anchor-bib' },
            _react2.default.createElement(_baseIcons.Pencil, null),
            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'button_edit' }),
            _react2.default.createElement(
              _reactIntl.FormattedMessage,
              { id: 'user_list_select_anchor_bib' },
              function (message) {
                return _react2.default.createElement(
                  _baseScreenReaderMessage2.default,
                  null,
                  message
                );
              }
            )
          )
        ),
        this.renderAuthor()
      );
    }
  }]);

  return AnchorBibDescriptionInput;
}(_baseBcReactComponent2.default);

AnchorBibDescriptionInput.propTypes = propTypes;

exports.default = AnchorBibDescriptionInput;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/anchor-bib-description-input/components/AnchorBibDescriptionInput.component.js
// module id = 1275
// module chunks = 0